import {
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useEffect, useReducer, useState } from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import ImageUpload from '../../../../../shared/image-upload/ImageUpload';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomMultiSelect from '../../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';
import {
  LANGUAGES,
  CHANNEL_TYPE,
  TVCHANNEL_CHANNELS_TYPE,
} from '../../../../../constants/TvChannelsConst';
import {
  bouquetSelector,
  categorySelector,
  fetchAllBouquets,
  fetchAllCategorys,
  fetchAllChannels,
  fetchChannelNumberList,
} from '../../../cmsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { formDataValidate, VALID_INTEGER } from '../../../../../utils/formUtils';
import { getProcessedImages } from '../../../../../shared/image-upload/ImageProcessor';
import { allHotelsSelector } from '../../../../property/propertySlice';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { createTVChannel, updateTVChannel } from '../../../../../utils/cmsUtils';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import CustomPopupModel from '../../../../../shared/custom-popup/Custom-Popup';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';
import { sortChannels } from '../../../../../utils/PropertyAPIUtils';

const CustomToolTip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'black',
  },
})(Tooltip);

const ChannelCreate = (props) => {
  const { toggleDrawer, hotelId, channel, showLoader } = props;
  const [categoryList, setCategoryList] = useState([]);
  const [bouquetList, setBouquetList] = useState([]);
  const categoryListData = useSelector(categorySelector);
  const bouquetListData = useSelector(bouquetSelector);
  const originalHotels = useSelector(allHotelsSelector);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [rawImages, setRawImages] = useState([]);
  const [bouquetSearchValue, setBouquetSearchValue] = useState('');
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [isDuplicateChannelNo, setIsDuplicateChannelNo] = useState(false);
  const [confirmPushChannel, setConfirmPushChannel] = useState(false);
  const [confirmSwapChannel, setConfirmSwapChannel] = useState(false);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    category: {
      value: '',
      fieldName: 'Select Category',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    bouquets: {
      value: '',
      fieldName: 'Select Bouquet(s)',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    name: {
      value: '',
      fieldName: 'Channel Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Channel Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    channelNumber: {
      value: '',
      fieldName: 'Channel Number',
      errors: {},
      validations: ['required', 'positiveOnly', VALID_INTEGER],
      tab: 0,
    },
    channelLanguage: {
      value: '',
      fieldName: 'Select Language',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: [],
      tab: 0,
    },
    externalURL: {
      value: '',
      fieldName: 'External URL',
      errors: {},
      validations: ['validUrl', 'safeURL'],
      tab: 0,
    },
    tvType: {
      value: 'IPTV',
      fieldName: 'Channel Mode',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    ipAddress: {
      value: '',
      fieldName: 'IP Address',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    ipPort: {
      value: '',
      fieldName: 'Port',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    digitalTelevisionFormat: {
      value: '',
      fieldName: 'Channel Type',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    frequency: {
      value: '',
      fieldName: 'Frequency',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    broadCastStandard: {
      value: '',
      fieldName: 'Broadcast Standard',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    modulationType: {
      value: '',
      fieldName: 'Modulation Type',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    bandwidth: {
      value: '',
      fieldName: 'Bandwidth',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    programNumber: {
      value: '',
      fieldName: 'Program Number',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    majorNumber: {
      value: '',
      fieldName: 'Major Number',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    polarization: {
      value: '',
      fieldName: 'Polarization',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    symbolRate: {
      value: '',
      fieldName: 'Symbol Rate',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    satelliteId: {
      value: '',
      fieldName: 'Satellite ID',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    isDRM: {
      value: false,
      fieldName: 'Is a DRM',
      errors: {},
      validations: [],
      tab: 0,
    },
    status: {
      value: true,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
    isEpgURL: {
      value: false,
      fieldName: 'EPG URL',
      errors: {},
      validations: [],
      tab: 0,
    },
    epgURL: {
      value: '',
      fieldName: 'EPG URL',
      errors: {},
      validations: ['required', 'validUrl'],
      tab: -1,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 1,
    },
  });

  useEffect(() => {
    if (categoryListData) setCategoryList(categoryListData);
  }, [setCategoryList, categoryListData]);

  useEffect(() => {
    if (bouquetListData) setBouquetList(bouquetListData);
  }, [setBouquetList, bouquetListData]);

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );

    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid);
  }, [formData, tabValue]);

  useEffect(() => {
    if (channel) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = channel[field];
      }
      currFields.category.value = channel.channelCategoryID;

      const bouquetInput = [];
      if (channel.bouquet && channel.bouquet.length > 0) {
        channel.bouquet.forEach((item) => {
          bouquetInput.push(item.id);
        });
      }
      onChangeChannelMode(channel.tvType);
      if (channel.tvType !== 'IPTV') {
        if (channel.coaxial && channel.coaxial.digitalTelevisionFormat) {
          changeValidationDigitalTelevisionFormat(channel.coaxial.digitalTelevisionFormat);
        }
      }

      currFields.status.value = channel?.status;
      currFields.bouquets.value = bouquetInput;
      currFields.ipAddress.value = channel?.iptv?.url;
      currFields.ipPort.value = channel?.iptv?.port;
      currFields.digitalTelevisionFormat.value = channel?.coaxial?.digitalTelevisionFormat;
      currFields.frequency.value = channel?.coaxial?.frequency;
      currFields.broadCastStandard.value = channel?.coaxial?.broadCastStandard;
      currFields.modulationType.value = channel?.coaxial?.modulationType;
      currFields.bandwidth.value = channel?.coaxial?.bandwidth;
      currFields.satelliteId.value = channel?.coaxial?.satelliteId;
      currFields.programNumber.value = channel?.coaxial?.programNumber;
      currFields.majorNumber.value = channel?.coaxial?.majorNumber;
      currFields.polarization.value = channel?.coaxial?.polarization;
      currFields.channelNumber.value = channel?.number;
      currFields.category.value = channel?.categoryId;
      currFields.channelLanguage.value = channel?.language;
      currFields.symbolRate.value = channel?.coaxial?.symbolRate;
      setFormData(currFields);
    }
  }, [channel]);

  const onSearchBouquetList = async (searchBouquet) => {
    setBouquetSearchValue(searchBouquet);
    if (searchBouquet === '') return setBouquetList(bouquetListData);
    const filterList = await bouquetListData.filter((item) => {
      return item.name.toLowerCase().includes(searchBouquet.toLowerCase());
    });
    return setBouquetList(filterList);
  };

  const BouquetRenderCustomDisplay = (selectedValue) => {
    const displayName = selectedValue.map((itemData) => {
        const item = bouquetListData.find((ild) => ild.id === itemData);
        return item?.name;
      })
      .filter(Boolean);
    const displayString = displayName.join(', ').replace(/^,?\s*/, '');
    const formItem = { ...formData.bouquets };
    formItem.fieldName = `${displayName.length} selected`;
    return <span>{displayString}</span>;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate(0) && validate(1)) {
      setLoading(true);
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        const images = await getProcessedImages(
          rawImages,
          originalHotels.find((hotel) => hotel.id === hotelId).groupId,
          TVCHANNEL_CHANNELS_TYPE,
          hotelId,
        );
        const iptv = {
          url: formData.ipAddress.value,
          port: formData.ipPort.value,
        };
        const coaxial = {
          digitalTelevisionFormat: formData?.digitalTelevisionFormat?.value,
          frequency: formData?.frequency?.value,
          broadCastStandard: formData?.broadCastStandard?.value,
          modulationType: formData?.modulationType?.value,
          bandwidth: formData?.bandwidth?.value,
          satelliteId: formData?.satelliteId?.value,
          programNumber: formData?.programNumber?.value,
          majorNumber: formData?.majorNumber?.value,
          polarization: formData?.polarization?.value,
          symbolRate: formData?.symbolRate?.value,
        };

        if (formData.tvType.value === 'IPTV') {
          coaxial.digitalTelevisionFormat = '';
          coaxial.frequency = '';
        }

        const bouquetInput = [];
        if (formData.bouquets.value && formData.bouquets.value.length > 0) {
          formData.bouquets.value.forEach((item) => {
            if (item) {
              bouquetInput.push({
                id: item,
                name: bouquetListData.find((bouquet) => bouquet.id === item)?.name || '',
              });
            }
          });
        }
        const payload = {
          name: formData.name.value,
          code: formData.code.value,
          channelNumber: formData.channelNumber.value,
          channelCategoryID: formData.category.value,
          channelLanguage: formData.channelLanguage.value,
          description: formData.description.value,
          externalURL: formData.externalURL.value,
          isDRM: formData.isDRM.value,
          tvType: formData.tvType.value,
          status: formData.status.value,
          isEpgURL: formData.isEpgURL.value,
          epgURL: formData.epgURL.value,
          images,
          iptv,
          coaxial,
          bouquetInput,
          pushChannel: confirmPushChannel,
        };
        payload.categoryName = categoryList.find(
          (category) => category.id === formData.category.value,
        ).name;
        if (channel?.id) {
          payload.id = channel.id;
          payload.swapChannel = confirmSwapChannel;
          await updateTVChannel(payload, hotelId, language);
          try {
            await sortChannels({ hotelId, isSort: true });
          } catch (e) {
            console.log('Auto-sort after edit failed:', e);
          }
          notificationManager('success', 'Channel updated successfully');
        } else {
          await createTVChannel(payload, hotelId, language);
          try {
            await sortChannels({ hotelId, isSort: true });
          } catch (e) {
            console.log('Auto-sort failed:', e);
          }
          notificationManager('success', 'Channel created successfully');
        }
        dispatch(fetchAllChannels(hotelId));
        dispatch(fetchAllBouquets(hotelId));
        dispatch(fetchAllCategorys(hotelId));
        dispatch(fetchChannelNumberList(hotelId));
        toggleDrawer('', false, '');
        setLoading(false);
      } catch (error) {
        if (error?.graphQLErrors) {
          if (error?.graphQLErrors?.[0]?.message === 'channel number already exists') {
            setIsDuplicateChannelNo(true);
          } else {
            notificationManager('danger', error?.graphQLErrors?.[0]?.message);
          }
        } else {
          channel
            ? notificationManager('danger', 'Failed to update Channel')
            : notificationManager('danger', 'Failed to create Channel');
        }
        setLoading(false);
      } finally {
        dispatch(stepDownLoaderCount());
      }
    } else {
      notificationManager('danger', 'Enter all required fields');
      if (!validate(2)) {
        setTabValue(2);
      }
      if (!validate(1)) {
        setTabValue(1);
      }
      if (!validate(0)) {
        setTabValue(0);
      }
    }
  };

  const validate = (tabValue) => {
    const updatedFields = {};
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else {
      if (validate(tabValue)) {
        setTabValue(newValue);
      }
    }
  };

  const onCancel = () => {
    toggleDrawer('', false, '');
  };

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData.images.value];
    images.splice(index, 1);
    setFormData({ images });
  };

  const changeValidationDigitalTelevisionFormat = (value) => {
    const updatedFormData = { ...formData };

    if (value === 'dtv') {
      updatedFormData.majorNumber.validations = ['required'];
      updatedFormData.satelliteId.validations = [];
      updatedFormData.symbolRate.validations = [];
      updatedFormData.polarization.validations = [];
      updatedFormData.frequency.validations = ['required'];
      updatedFormData.broadCastStandard.validations = ['required'];
      updatedFormData.frequency.validations = ['required'];
      updatedFormData.modulationType.validations = ['required'];
      updatedFormData.bandwidth.validations = ['required'];
      updatedFormData.programNumber.validations = ['required'];
      updatedFormData.majorNumber.tab = 0;
      updatedFormData.satelliteId.tab = -1;
      updatedFormData.bouquets.tab = -1;
      updatedFormData.polarization.tab = -1;
    } else if (value === 'sdtv') {
      updatedFormData.majorNumber.validations = [];
      updatedFormData.satelliteId.validations = ['required'];
      updatedFormData.polarization.validations = ['required'];
      updatedFormData.frequency.validations = ['required'];
      updatedFormData.broadCastStandard.validations = ['required'];
      updatedFormData.modulationType.validations = ['required'];
      updatedFormData.bandwidth.validations = ['required'];
      updatedFormData.programNumber.validations = ['required'];
      updatedFormData.symbolRate.validations = [];
      updatedFormData.majorNumber.tab = -1;
      updatedFormData.satelliteId.tab = 0;
      updatedFormData.polarization.tab = 0;
    } else if (value === 'cdtv') {
      updatedFormData.majorNumber.validations = ['required'];
      updatedFormData.satelliteId.validations = [];
      updatedFormData.polarization.validations = [];
      updatedFormData.symbolRate.validations = ['required'];
      updatedFormData.majorNumber.tab = 0;
      updatedFormData.satelliteId.tab = -1;
      updatedFormData.polarization.tab = -1;
      updatedFormData.symbolRate.tab = 0;
    }
    setFormData(updatedFormData);
  };

  const changeDigitalTelevisionFormat = (e) => {
    const selectedValue = e.value;
    if (formData?.digitalTelevisionFormat.value != selectedValue) {
      const updatedFormData = { ...formData };
      updatedFormData.broadCastStandard.value = '';
      updatedFormData.frequency.value = '';
      updatedFormData.modulationType.value = '';
      updatedFormData.bandwidth.value = '';
      updatedFormData.satelliteId.value = '';
      updatedFormData.polarization.value = '';
      updatedFormData.programNumber.value = '';
      updatedFormData.symbolRate.value = '';
      updatedFormData.majorNumber.value = '';
      updatedFormData.digitalTelevisionFormat.value = selectedValue;

      setFormData(updatedFormData);
      changeValidationDigitalTelevisionFormat(e.value);
    } else {
      setFormData({ ...formData, digitalTelevisionFormat: e });
    }
  };

  const onChangeChannelMode = (value) => {
    if (value === 'IPTV') {
      formData.ipAddress.validations = ['required'];
      formData.ipPort.validations = ['required'];
      formData.digitalTelevisionFormat.validations = [];
      formData.frequency.validations = [];
      formData.broadCastStandard.validations = [];
      formData.modulationType.validations = [];
      formData.bandwidth.validations = [];
      formData.programNumber.validations = [];
      formData.majorNumber.validations = [];
      formData.ipAddress.tab = 0;
      formData.ipPort.tab = 0;
      formData.digitalTelevisionFormat.tab = -1;
      formData.frequency.tab = -1;
      formData.broadCastStandard.tab = -1;
      formData.modulationType.tab = -1;
      formData.bandwidth.tab = -1;
      formData.programNumber.tab = -1;
      formData.majorNumber.tab = -1;
    } else {
      formData.ipAddress.validations = [];
      formData.ipPort.validations = [];
      formData.digitalTelevisionFormat.validations = ['required'];
      formData.frequency.validations = ['required'];
      formData.broadCastStandard.validations = ['required'];
      formData.modulationType.validations = ['required'];
      formData.bandwidth.validations = ['required'];
      formData.programNumber.validations = ['required'];
      formData.majorNumber.validations = ['required'];
      formData.ipAddress.tab = -1;
      formData.ipPort.tab = -1;
      formData.digitalTelevisionFormat.tab = 0;
      formData.frequency.tab = 0;
      formData.broadCastStandard.tab = 0;
      formData.modulationType.tab = 0;
      formData.bandwidth.tab = 0;
      formData.programNumber.tab = 0;
      formData.majorNumber.tab = 0;
    }
    const channelMode = { ...formData.tvType };
    channelMode.value = value;
    setFormData({ tvType: channelMode });
  };

  const handleActiveChange = (event) => {
    const currField = { ...formData.isEpgURL };
    currField.value = event.target.checked;
    if (currField.value) {
      formData.epgURL.validations = ['required', 'validUrl'];
      formData.epgURL.tab = 0;
    } else {
      formData.epgURL.validations = [];
      formData.epgURL.tab = -1;
    }
    setFormData({ isEpgURL: currField });
  };

  const handleDRMChange = (event) => {
    const currField = { ...formData.isDRM };
    currField.value = event.target.checked;
    setFormData({ isDRM: currField });
  };

  const statusChange = (event) => {
    const currField = { ...formData.status };
    currField.value = event.target.checked;
    setFormData({ status: currField });
  };

  const onNextClick = () => {
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };
  const modalPostion = () => {
    const top = 60;
    const left = 70;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  };

  const digitalTelevisionFormat = formData.digitalTelevisionFormat.value;

  return (
    <>
      {isDuplicateChannelNo === true && (
        <CustomPopupModel
          popUp={
            channel?.id
              ? {
                  status: isDuplicateChannelNo,
                  name: '',
                  title: 'Would you like to swap or push the channel number into the sequence?',
                  description: '',
                  buttonName: 'Push into Sequence',
                  swapBtn: 'Swap',
                }
              : {
                  status: isDuplicateChannelNo,
                  name: '',
                  title: 'Push Channel into sequence?',
                  description:
                    'The new channel will be pushed into the existing sequence and other channel numbers will be adjusted accordingly',
                  buttonName: 'Confirm',
                }
          }
          modalPostion={modalPostion}
          onClickSwap={() => {
            setIsDuplicateChannelNo(false);
            setConfirmSwapChannel(true);
          }}
          onClick={() => {
            setIsDuplicateChannelNo(false);
            setConfirmPushChannel(true);
          }}
          onClickCancel={() => {
            setIsDuplicateChannelNo(false);
          }}
        />
      )}
      <form onSubmit={handleSubmit} className='category-create' noValidate>
        <div className='container pt-4 d-flex align-items-end flex-column'>
          <div className='row px-3 w-100 mt-4'>
            <div className='col-md-6'>
              <span className='page-title'>{channel ? 'Edit Channel' : 'Add Channel'}</span>
            </div>
            <div className='col-md-5'>
              <Tabs
                value={tabValue}
                variant='fullWidth'
                indicatorColor='primary'
                onChange={handleTabChange}
                aria-label='hotel-add-tabs'
                textColor='primary'
                className='property-tabs'
              >
                <Tab label='Details' />
                <Tab label='Media' />
              </Tabs>
            </div>
            <div className='col-md-1 d-flex justify-content-end'>
              <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
                <CancelIcon />
              </IconButton>
            </div>
          </div>
          <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
            {tabValue === 0 && (
              <div className='col-md-12 mb-3'>
                <h4 className='tab-title'>Details</h4>
                <div className='row'>
                  <div className='col-md-6 mb-3'>
                    <CustomTextField
                      item={formData.name}
                      handleInputChange={(e) => {
                        setFormData({ name: e });
                      }}
                      maxLength={100}
                      multiline={true}
                      endAdornment={true}
                      characterCount={true}
                    />
                  </div>
                  <div className='col-md-6 mb-3'>
                    <CustomTextField
                      item={formData.code}
                      handleInputChange={(e) => {
                        setFormData({ code: e });
                      }}
                      maxLength={8}
                      endAdornment={true}
                      characterCount={true}
                      multiline={true}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-6 mb-3'>
                    <CustomSelect
                      item={formData.category}
                      handleInputChange={(e) => {
                        setFormData({ category: e });
                      }}
                      labelField='name'
                      valueField='id'
                      options={categoryList}
                      hideNullOption={true}
                    />
                  </div>
                  <div className='col-md-6 mb-3'>
                    <CustomMultiSelect
                      item={formData.bouquets}
                      options={bouquetList}
                      hideNullOption={true}
                      valueField='id'
                      labelField='name'
                      handleInputChange={(e) => setFormData({ bouquets: e })}
                      isSearchable={true}
                      getSearchInput={onSearchBouquetList}
                      searchValue={bouquetSearchValue}
                      searchPlaceholder='Search'
                      isCustomDisplay={true}
                      renderCustomDisplay={BouquetRenderCustomDisplay}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-6 mb-3'>
                    <CustomTextField
                      item={formData.channelNumber}
                      handleInputChange={(e) => {
                        setFormData({ channelNumber: e });
                      }}
                      max={99999}
                      type={'number'}
                    />
                  </div>
                  <div className='col-md-6 mb-3'>
                    <CustomSelect
                      item={formData.channelLanguage}
                      handleInputChange={(e) => {
                        setFormData({ channelLanguage: e });
                      }}
                      labelField='name'
                      valueField='id'
                      options={LANGUAGES}
                      hideNullOption={true}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-12 mb-3'>
                    <CustomTextField
                      item={formData.description}
                      handleInputChange={(e) => {
                        setFormData({ description: e });
                      }}
                      multiline={true}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-12 mb-3'>
                    <CustomTextField
                      item={formData.externalURL}
                      handleInputChange={(e) => {
                        setFormData({ externalURL: e });
                      }}
                      multiline={true}
                    />
                  </div>
                </div>
                <div className='custom-upload col-md-12'>
                  <RadioGroup
                    row
                    aria-label={formData.tvType.fieldName}
                    onChange={(e) => {
                      onChangeChannelMode(e.target.value);
                    }}
                    value={formData.tvType.value}
                    name={formData.tvType.fieldName}
                    className='document-type mb-3'
                  >
                    <FormControlLabel
                      value='IPTV'
                      control={<Radio color='primary' />}
                      label='IPTV'
                      className='me-5'
                    />
                    <FormControlLabel
                      value='COAXIAL'
                      control={<Radio color='primary' />}
                      label='Coaxial'
                    />
                  </RadioGroup>
                </div>
                {formData.tvType.value === 'IPTV' && (
                  <>
                    <div className='row'>
                      <div className='col-md-6 mb-3'>
                        <CustomTextField
                          item={formData.ipAddress}
                          handleInputChange={(e) => {
                            setFormData({ ipAddress: e });
                          }}
                          maxLength={30}
                          endAdornment={true}
                        />
                      </div>
                      <div className='col-md-6 mb-3'>
                        <CustomTextField
                          item={formData.ipPort}
                          handleInputChange={(e) => {
                            setFormData({ ipPort: e });
                          }}
                          maxLength={10}
                          endAdornment={true}
                        />
                      </div>
                    </div>
                  </>
                )}
                {formData.tvType.value === 'COAXIAL' && (
                  <>
                    <div className='row'>
                      <div className='col-md-6 mb-3'>
                        <CustomSelect
                          item={formData.digitalTelevisionFormat}
                          handleInputChange={(e) => {
                            changeDigitalTelevisionFormat(e);
                          }}
                          labelField='name'
                          valueField='id'
                          options={CHANNEL_TYPE}
                          hideNullOption={true}
                        />
                      </div>
                      <div className='col-md-6 mb-3'>
                        <CustomTextField
                          item={formData.frequency}
                          handleInputChange={(e) => {
                            setFormData({ frequency: e });
                          }}
                          maxLength={30}
                          endAdornment={true}
                        />
                      </div>
                    </div>
                    {digitalTelevisionFormat !== '' && (
                      <>
                        <div className='row'>
                          <div className='col-md-6 mb-3'>
                            <CustomTextField
                              item={formData.broadCastStandard}
                              handleInputChange={(e) => {
                                setFormData({ broadCastStandard: e });
                              }}
                              maxLength={30}
                              endAdornment={true}
                            />
                          </div>
                          <div className='col-md-6 mb-3'>
                            <CustomTextField
                              item={formData.modulationType}
                              handleInputChange={(e) => {
                                setFormData({ modulationType: e });
                              }}
                              maxLength={30}
                              endAdornment={true}
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-md-6 mb-3'>
                            <CustomTextField
                              item={formData.bandwidth}
                              handleInputChange={(e) => {
                                setFormData({ bandwidth: e });
                              }}
                              maxLength={30}
                              endAdornment={true}
                            />
                          </div>
                          {digitalTelevisionFormat === 'sdtv' && (
                            <>
                              <div className='col-md-6 mb-3'>
                                <CustomTextField
                                  item={formData.satelliteId}
                                  handleInputChange={(e) => {
                                    setFormData({ satelliteId: e });
                                  }}
                                  maxLength={30}
                                  endAdornment={true}
                                />
                              </div>
                            </>
                          )}
                          <div className='col-md-6 mb-3'>
                            <CustomTextField
                              item={formData.programNumber}
                              handleInputChange={(e) => {
                                setFormData({ programNumber: e });
                              }}
                              maxLength={30}
                              endAdornment={true}
                            />
                          </div>
                          {digitalTelevisionFormat === 'dtv' && (
                            <>
                              <div className='col-md-6 mb-3'>
                                <CustomTextField
                                  item={formData.majorNumber}
                                  handleInputChange={(e) => {
                                    setFormData({ majorNumber: e });
                                  }}
                                  maxLength={30}
                                  endAdornment={true}
                                />
                              </div>
                            </>
                          )}
                          {digitalTelevisionFormat === 'sdtv' && (
                            <>
                              <div className='col-md-6 mb-3'>
                                <CustomTextField
                                  item={formData.polarization}
                                  handleInputChange={(e) => {
                                    setFormData({ polarization: e });
                                  }}
                                  maxLength={30}
                                  endAdornment={true}
                                />
                              </div>
                            </>
                          )}
                          {digitalTelevisionFormat === 'cdtv' && (
                            <>
                              <div className='col-md-6 mb-3'>
                                <CustomTextField
                                  item={formData.majorNumber}
                                  handleInputChange={(e) => {
                                    setFormData({ majorNumber: e });
                                  }}
                                  maxLength={30}
                                  endAdornment={true}
                                />
                              </div>
                            </>
                          )}
                          {digitalTelevisionFormat === 'cdtv' && (
                            <>
                              <div className='col-md-6 mb-3'>
                                <CustomTextField
                                  item={formData.symbolRate}
                                  handleInputChange={(e) => {
                                    setFormData({ symbolRate: e });
                                  }}
                                  maxLength={30}
                                  endAdornment={true}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </>
                )}
                <div className='row'>
                  <div className='col-md-6 mb-3 gray-text'>
                    <Checkbox
                      checked={formData.isEpgURL.value}
                      onChange={handleActiveChange}
                      className='status-checkbox'
                      color='primary'
                    />{' '}
                    Add EPG URL
                  </div>
                </div>
                {formData.isEpgURL.value && (
                  <>
                    <div className='row'>
                      <div className='col-md-12 mb-3'>
                        <CustomTextField
                          item={formData.epgURL}
                          handleInputChange={(e) => {
                            setFormData({ epgURL: e });
                          }}
                          multiline={true}
                        />
                      </div>
                    </div>
                  </>
                )}
                <div className='row'>
                  <div className='col-md-6 mb-3 gray-text'>
                    <Checkbox
                      checked={formData.isDRM.value}
                      onChange={handleDRMChange}
                      className='status-checkbox'
                      color='primary'
                    />{' '}
                    Is a DRM
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-3 mb-3'>
                    <div className='d-flex align-items-center'>
                      <Checkbox
                        checked={formData?.status?.value}
                        onChange={statusChange}
                        className='status-checkbox'
                        color='primary'
                      />{' '}
                      <span style={{ fontWeight: 500 }}>Active</span>
                      <CustomToolTip
                        title='Deactivating a channel hides it from the TV'
                        placement='right-end'
                      >
                        <InfoIcon style={{ marginLeft: 8, fontSize: 18 }} />
                      </CustomToolTip>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {tabValue === 1 && (
              <div className='col-md-12 mb-3'>
                <ImageUpload
                  uploadedImages={formData.images.value}
                  imgList={rawImages}
                  onImageListUpdated={onImageListUpdated}
                  onUploadedImageRemoval={onUploadedImageRemoval}
                  allowedImageSize={1}
                  resolutionWidth={'576'}
                  resolutionHeight={'354'}
                  ratio21to9Needed={'false'}
                  onImagesLoading={(status) => {
                    setLoading(status);
                  }}
                  enabledMediaTabs={['image']}
                />
              </div>
            )}
          </div>
          <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
            <div className='col-md-12 d-flex justify-content-start'>
              {tabValue < 1 ? (
                <Button
                  variant='contained'
                  color='primary'
                  onClick={onNextClick}
                  size='large'
                  className='me-3'
                  disabled={isTabInValid}
                >
                  Next
                </Button>
              ) : (
                <Button
                  disabled={loading}
                  onClick={handleSubmit}
                  variant='contained'
                  color='primary'
                  className='me-3'
                  size='large'
                >
                  {channel ? 'Update' : 'Add'}
                </Button>
              )}
              <Button
                disabled={loading}
                variant='outlined'
                type='button'
                color='secondary'
                size='large'
                onClick={(e) => onCancel(e)}
              >
                Cancel
              </Button>
            </div>
            {loading && <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>}
          </div>
        </div>
      </form>
    </>
  );
};

export default ChannelCreate;
